import React from "react";
import Particles from "react-particles-js";

const CoverParticles = () => (
  <Particles
    className="cover"
    params={{
      particles: {
        number: {
          value: 18
        },
        size: {
          value: 15
        }
      },

      interactivity: {
        events: {
          onhover: {
            enable: true,
            mode: "grab"
          }
        }
      }
    }}
    style={{
      background:
        "linear-gradient(-370deg, rgb(121, 45, 179) 0%, rgb(93, 72, 210) 30%, rgba(0,212,255,1) 100%)"
    }}
  />
);

export default CoverParticles;
